import script from "./PromoList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromoList.vue?vue&type=script&lang=ts&setup=true"

import "./PromoList.vue?vue&type=style&index=0&id=34cee244&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cee244"]])

export default __exports__